import {Injectable} from '@angular/core';
import {Chart, HIGHCHARTS_MODULES} from 'angular-highcharts';
import {Options} from "highcharts";

@Injectable({
  providedIn: 'root'
})
export class ChartService {

  constructor() {
  }

  public getChart(rainfall: any, crop: any, fallow: any, bos: any, bosText: string, title: string) {
    const lineSize = 2;
    let chartOptions: Options = {
      chart: {
        type: 'spline',
        plotBorderWidth: 1,
        events: {
          load: function () {
            var imagePath = 'https://www.agric.wa.gov.au/sites/all/modules/submodules/soilwater/assets/chart-header.png';
            //var imagePath = $location.protocol() + '://' + $location.host() + drupalModulePath + 'images/chart-header.png';
            this.renderer.image(imagePath, 80, 60, 303, 66).attr({zIndex: 7}).add();
          }
        }
      },
      title: {
        text: title
      },
      credits: {
        enabled: true,
        text: 'Copyright Western Australian Agriculture Authority, ' + new Date().getFullYear(),
        href: 'http://www.agric.wa.gov.au'
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {day: '%e/%y'},
        tickInterval: 14 * 24 * 3600 * 1000, // one fortnight
        tickWidth: 0,
        gridLineWidth: 1,
        plotLines: [{
                color: 'gray',
                dashStyle: 'ShortDash',
                width: lineSize,
                value: bos,
                label: {
                  text: bosText
                }
              }]
      },
      yAxis: {
        title: {text: 'Soil water (mm)'},
        tickInterval: 10,
        min: 0,
        maxPadding: 0.2 // Added so logo doesn't overlap data.
      },
      tooltip: {
        backgroundColor: 'rgba(255,255,255,1)',
        shared: true,
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>'
      },
      plotOptions: {
        line: {
          lineWidth: lineSize,
          states: {
            hover: {
              lineWidth: lineSize+1
            }
          },
          marker: {
            enabled: false
          }
        },
        spline: {
          lineWidth: lineSize,
          states: {
            hover: {
              lineWidth: lineSize + 1
            }
          },
          marker: {
            enabled: false
          }
        }
      },
      series: [
        {
          name: 'Soil water (fallow)',
          type: 'spline',
          color: '#331a00',
          data: fallow
        },
        {
          name: 'Soil water (crop)',
          type: 'spline',
          color: '#00cc00',
          data: crop
        },
        {
          name: 'Rainfall',
          type: 'line',
          color: 'rgb(0, 60, 105)',
          borderWidth: 0,
          data: rainfall
        }
      ]
    };

    return new Chart(chartOptions);

  }
}
